import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MentionModule } from 'angular-mentions';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';

export type ButtonSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    MentionModule,
  ],
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnChanges {
  @ViewChild('input', { static: false })
  input!: ElementRef<HTMLInputElement>;

  @Input() size: ButtonSize = 'medium';
  @Input() type: string = 'text';
  @Input() readOnly: boolean = false;
  @Input() highlight: boolean = false;
  @Input() initialValue?: any;
  @Input() placeholder?: string;
  @Input() label?: string;
  @Input() id?: string;
  @Input() control?: FormControl;
  @Input() shouldFocus: boolean = false;
  @Input() mentionData: string[] = [];

  @Output() focused = new EventEmitter<void>();

  public mentionConfig = {
    items: [] as string[],
    triggerChar: '@' as string,
    labelKey: undefined as string | undefined,
  };

  protected passwordVisible: boolean = false;
  protected readonly icons = {
    eye: faEye,
    eyeClosed: faEyeSlash,
  };

  ngOnChanges(c: SimpleChanges): void {
    if (this.shouldFocus) {
      this.focus();
    }
    if (c['mentionData']) {
      this.mentionConfig.items = this.mentionData;
    }
  }

  get resolvedType(): string {
    if (this.type === 'password') {
      return this.passwordVisible ? 'text' : 'password';
    }
    return this.type;
  }

  onFocus(): void {
    this.focused.emit();
  }

  togglePasswordView(): void {
    this.passwordVisible = !this.passwordVisible;
  }

  private focus(): void {
    setTimeout(() => this.input?.nativeElement?.focus());
  }
}
